<sgt-multi-select
  [settings]="settings"
  [options]="options"
  [variante]="variante"
  [(ngModel)]="tipos"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()">
</sgt-multi-select>
